import {notNull} from "./assert.js";
import type {SlButton} from "@shoelace-style/shoelace/shoelace.js";
export default class HeroImage {

    constructor(heroImageModule: HTMLElement, useBlur: boolean) {
        this.showHeadings(heroImageModule).then(() => this.intersect(heroImageModule, useBlur));
    }

    private async showHeadings(heroImageModule: HTMLElement)
    {
        const headings = heroImageModule.querySelector<HTMLDivElement>('.hero-headings');

        if (!headings) {
            return;
        }

        const button = heroImageModule.querySelector<SlButton>('sl-button');

        if (!button) {
            headings.classList.add('ready');
            return;
        }

        await Promise.allSettled([
            customElements.whenDefined('sl-button'),
        ]);

        if (headings) {
            headings.classList.add('ready');
        }
    }

    private intersect(heroImageModule: HTMLElement, useBlur: boolean)
    {
        if (! useBlur) {
            return;
        }

        const observer = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if(entry.isIntersecting) {
                    observer.unobserve(entry.target);
                    observer.disconnect();

                    const blurryElement = notNull(heroImageModule.querySelector<HTMLDivElement>('.blur'));
                    const contentContainer = notNull(heroImageModule.querySelector<HTMLDivElement>('.picture'));
                    const heroImageDetails = notNull(heroImageModule.querySelector('.hero-image-details'));

                    if (window.innerWidth < 1024) {
                        blurryElement.style.width = '100%';
                        return;
                    }

                    if (contentContainer.querySelector('.container-left')) {
                        blurryElement.style.width = heroImageDetails.getBoundingClientRect().right + 'px';
                    } else if (contentContainer.querySelector('.container-right')) {
                        const contentDimensions = heroImageDetails.getBoundingClientRect();
                        const bodyDimension = notNull(document.querySelector('body')).getBoundingClientRect();
                        blurryElement.style.width = (bodyDimension.right - contentDimensions.right + contentDimensions.width) + 'px';
                    }
                }
            });
        }, {rootMargin: '0px',  threshold: 0.75,});

        observer.observe(heroImageModule)
    }
}

